var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHudd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5043 1C2.95202 1 2.5043 1.44772 2.5043 2V13.3306L2.50049 13.3367L2.50224 13.3398L2.5043 13.3378V19.5989C2.5043 19.8513 2.50397 20.2119 2.50351 20.5957C2.50218 21.695 3.38789 22.5907 4.48716 22.5965C4.76961 22.5979 5.02916 22.5989 5.22217 22.5989H6.00018C7.10475 22.5989 8.00018 21.7035 8.00018 20.5989V14C8.00018 11.7909 9.79104 10 12.0002 10C14.2093 10 16.0002 11.7909 16.0002 14V20.5989C16.0002 21.7035 16.8956 22.5989 18.0002 22.5989H19.0367C19.2483 22.5989 19.54 22.5989 19.8561 22.5989C20.9607 22.5989 21.8563 21.7033 21.8563 20.5987C21.8563 20.2103 21.8563 19.8473 21.8563 19.5989V12.0227C21.8563 11.0744 21.408 10.182 20.6472 9.6159L13.9712 4.64822C12.9083 3.85727 11.4524 3.85727 10.3894 4.64822L5.7983 8.0645L7.59412 5.19353C7.79303 4.87552 7.89851 4.50799 7.89851 4.13291V2C7.89851 1.44772 7.4508 1 6.89851 1H3.5043Z",
    fill: "#CCE8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHudd);
export default __webpack_public_path__ + "static/media/hudd.800477a9f31595a84f0be3f20a94cc8b.svg";
export { ForwardRef as ReactComponent };